import { EnvironmentInterface } from './environment.interface';
import { FlagEnum } from '../../../modules/src/lib/core/enums/flag.enum';
import { SeverityTypeEnum } from '../../../modules/src/lib/core/enums/severity-type.enum';

export const environment: EnvironmentInterface = {
  name: 'production',
  production: true,
  apiUrl: 'https://api.optitax.ca',
  auth0Audience: 'https://api.optitax.ca',
  isDebug: false,
  logging: {
    severityType: SeverityTypeEnum.Warning,
  },
  flags: {
    [FlagEnum.PortalFileUploads]: false,
    [FlagEnum.ClientQuestionnairesQuebec2022TaxForm]: true,
  },
};
